import { render } from "./CurrentLoan.vue?vue&type=template&id=1dce99fc&scoped=true"
import script from "./CurrentLoan.vue?vue&type=script&lang=js"
export * from "./CurrentLoan.vue?vue&type=script&lang=js"

import "./CurrentLoan.vue?vue&type=style&index=0&id=1dce99fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce99fc"]])

export default __exports__